import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { __rest } from "tslib";
import React, { Component } from 'react';
import { DragDropContext as context } from 'react-dnd';
import backend from 'react-dnd-html5-backend';
import SortableItem from './SortableItem';
var Sortable = /*#__PURE__*/function (_Component) {
  _inherits(Sortable, _Component);
  var _super = _createSuper(Sortable);
  function Sortable() {
    _classCallCheck(this, Sortable);
    return _super.apply(this, arguments);
  }
  _createClass(Sortable, [{
    key: "render",
    value: function render() {
      var _a = this.props,
        children = _a.children,
        onItemsSort = _a.onItemsSort,
        onItemDrag = _a.onItemDrag,
        onItemHover = _a.onItemHover,
        tag = _a.tag,
        rest = __rest(_a, ["children", "onItemsSort", "onItemDrag", "onItemHover", "tag"]);
      var childrenProps = {
        onItemsSort: onItemsSort,
        onItemDrag: onItemDrag,
        onItemHover: onItemHover
      };
      return /*#__PURE__*/React.createElement(this.props.tag, Object.assign({}, rest), children.map(function (item, index) {
        return /*#__PURE__*/React.createElement(SortableItem, Object.assign({
          key: index,
          index: index
        }, childrenProps), item);
      }));
    }
  }]);
  return Sortable;
}(Component);
Sortable.defaultProps = {
  tag: 'div'
};
export default context(backend)(Sortable);